import axios from 'axios';
import {
    Approval,
    Company,
    Deal,
    Vendor,
    Bill,
    Offer,
    DataConnection,
    RateCurve,
} from '@lendica/utils';
import { useCompanyApi } from '@lendica/hooks';
import { useMemo } from 'react';
import { v2 } from '@lendica/api';

export const awsURL = 'https://micro-awsmanager.herokuapp.com/s3';
export const presignedUrl = `${awsURL}/signed-url`;
export const bucket_name = 'lendica-pod';

export interface BillDetails {
    bill: Bill;
    vendor: Vendor | null;
    company: Company;
}

export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>;
      }
    : T;

export interface ProcessBillReponse extends BillDetails {}

export interface ConfirmBillDetailsResponse extends BillDetails {
    confirm_success: boolean;
}

export const payLaterAPI = {
    // async getPaylaterApproval(): Promise<Approval | undefined> {
    //     const approvalsList = (await axios.get<Approval[]>('/company/approvals')).data;
    //     return approvalsList.find(
    //         approval => approval.active === true && approval.product_name === 'paylater'
    //     );
    // },
    // async processBill(objectKey: string): Promise<ProcessBillReponse> {
    //     return (
    //         await axios.post<ProcessBillReponse>('/paylater/bill/process', {
    //             object_name: objectKey,
    //             object_folder: 'lendica-pod',
    //         })
    //     ).data;
    // },
    // async getBillDetails(id: string): Promise<BillDetails> {
    //     return (await axios.get<BillDetails>(`/paylater/bill/confirm?bill_id=${id}`)).data;
    // },
    // async confirmBillDetails(data: DeepPartial<BillDetails>) {
    //     return (
    //         await axios.post<ConfirmBillDetailsResponse>(
    //             `/paylater/bill/confirm?bill_id=${data!.bill!.id}`,
    //             data
    //         )
    //     ).data;
    // },
    // async getBillsList(): Promise<Bill[]> {
    //     return (await axios.get<Bill[]>(`/company/bills`)).data;
    // },
    // async getBill(id: string): Promise<Bill> {
    //     return (await axios.get<Bill>(`/company/bills?id=${id}`)).data;
    // },
    // async archiveBill(id: string) {
    //     return (await axios.get<Bill>(`/company/bills/archive?id=${id}`)).data;
    // },
    // async getOffers(billId: string): Promise<Offer[]> {
    //     return (await axios.get<{ offers: Offer[] }>(`/paylater/bill/offers?bill_id=${billId}`))
    //         .data.offers;
    // },
    // async getPaylaterDealsList(): Promise<Deal[]> {
    //     const dealsList = (await axios.get<Deal[]>(`/company/deals`)).data;
    //     return dealsList.filter(deal => deal.product_name === 'paylater');
    // },
    // async getDeal(id: string): Promise<Deal> {
    //     return (await axios.get<Deal>(`/company/deals?id=${id}`)).data;
    // },
    async updateDataConsent(data_consent = true) {
        return (await axios.post('/company/consent', { data_consent })).data;
    },
    async getApplication(): Promise<any> {
        return (await axios.get<any>(`/application`)).data;
    },
    async postApplication(data: any) {
        return (await axios.post('/application', data)).data;
    },
    async getPreApproval(): Promise<any> {
        return (await axios.get<any>(`/lens/report`)).data;
    },
    // async initializeDeal(bill_id: string, offer_id: string) {
    //     return (await axios.post('/paylater/deal/init', { bill_id, offer_id })).data.deal.id;
    // },
    // async getVendorsList(): Promise<Vendor[]> {
    //     return (await axios.get('/company/vendors')).data;
    // },
    // async postVendor(data: any) {
    //     return (await axios.post('/company/vendors', data)).data;
    // },
    // async postVendorToBill(data: any, billId: string) {
    //     return (
    //         await axios.post('/company/vendors', {
    //             bill_id: billId,
    //             vendor: data,
    //         })
    //     ).data;
    // },
    // async getCompanyDetails() {
    //     return (await axios.get('/company/details')).data;
    // },
    // async getDataConnections() {
    //     return (await axios.get('/company/connections')).data;
    // },
    // async activatePaylater() {
    //     return (await axios.get('/paylater/activate')).data;
    // },
    // async getBillOffers(billId: string): Promise<Offer[]> {
    //     return (await axios.get(`/paylater/bill/offers?bill_id=${billId}`)).data;
    // },
};

export const usePayLaterApi = () => {
    const api = useCompanyApi();
    return useMemo(
        () => ({
            getCompanyDetail: () => api.get('/companies/detail'),
            getPaylaterApproval: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Approval>>('/approvals/list', {
                    params: {
                        product_name: 'paylater',
                        active: true,
                        page,
                        page_size: pageSize,
                    },
                }),
            getApprovalSummary: async (page = 1, pageSize = 20) => {
                let paylaterApproval = await api.get<v2.PaginatedResponse<Approval>>(
                    '/approvals/list',
                    {
                        params: {
                            product_name: 'paylater',
                            active: true,
                            page,
                            page_size: pageSize,
                        },
                    }
                );
                const rateCurves = await api.get<RateCurve[]>('/ratecurve_backbones/detail');
                return paylaterApproval.results.map(approval => {
                    const rcs = rateCurves.filter(rateCurve => rateCurve.approval === approval.id);
                    return { ...approval, rateCurve: rcs.sort((a, b) => a.day - b.day) };
                });
            },
            getBillsList: () => api.get<Bill[]>('/bills'),
            getBillsListPaginated: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Bill>>('/bills/list', {
                    params: {
                        page,
                        page_size: pageSize,
                    },
                }),
            getBill: (id: string) => api.get<Bill>(`/bills/detail?bill_id=${id}`),
            getBillDetails: (id: string) =>
                api.get<BillDetails>(`/paylater/bill/confirm?bill_id=${id}`),
            getDealsListPaginated: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Deal>>('/deals/list', {
                    params: {
                        product_name: 'paylater',
                        page,
                        page_size: pageSize,
                    },
                }),
            getDeal: (id: string) => api.get<Deal>(`/deals/detail?deal_id=${id}`),
            processBill: (objectKey: string) =>
                api.post<ProcessBillReponse>('/paylater/bill/process', {
                    object_name: objectKey,
                    object_folder: 'lendica-pod',
                }),
            confirmBillDetails: (data: DeepPartial<BillDetails>) =>
                api.post<{ bill_id: string }>(
                    `/paylater/bill/confirm?bill_id=${data!.bill!.id}`,
                    data
                ),
            initializeDeal: async (bill_id: string, offer_id: string) => {
                const data = await api.post<{ deal: Deal }>('/paylater/deal/init', {
                    bill_id,
                    offer_id,
                });
                return data.deal.id;
            },
            postVendorToBill: (vendor: Vendor, billId: string) =>
                api.post<Vendor>('/vendors', { bill_id: billId, vendor }, { unwrap: false }),
            archiveBill: (id: string) => api.get<Bill>(`/bills/archive?id=${id}`),
            getOffers: (billId: string) =>
                api.get<{ bill: Bill; offers: Offer[] }>(`/paylater/bill/offers?bill_id=${billId}`),
            getVendorsList: async (page = 1, pageSize = 50) => {
                const data = await api.get<v2.PaginatedResponse<Vendor>>('/vendors/list', {
                    params: {
                        page,
                        page_size: pageSize,
                    },
                });
                return data.results;
            },
            updateVendor: (vendor: DeepPartial<Vendor>) =>
                api.post<Vendor>('/vendors/update', { vendor_id: vendor.id, ...vendor }), // including vendor id
            createVendor: (vendor: DeepPartial<Vendor>) =>
                api.post<Vendor>('/vendors/create', vendor),
            getDataConnections: () => api.get<DataConnection[]>('/connections'),
            // TODO: handle v2 pagination
            getDataConnectionsList: async (page = 1, pageSize = 50) => {
                const data = await api.get<v2.PaginatedResponse<DataConnection>>(
                    '/connections/list',
                    {
                        params: {
                            page,
                            page_size: pageSize,
                        },
                    }
                );
                return data.results;
            },
            activatePaylater: () => api.get('/paylater/activate'),
        }),
        [api]
    );
};
